export const copy = {
  meta: {
    title: "Tower-Integrations",
    description: "Tower-Integrations delivers custom software solutions for manufacturers and businesses.",
  },
  hero: {
    title: "TOWER-INTEGRATIONS",
    subtitles: [
      "Custom Software Solutions",
    ]
  },
  about: {
    title: "About",
    description: "Build better with Tower-Integrations. Custom software for manufacturing, digital library systems, factory QA tracking, and hardware-integrated solutions."
  },
  work: {
    title: "FEATURED WORK",
    description: "Explore our latest projects."
  },
  payment: {
    title: "PAYMENT",
    description: "Enter your Stripe Invoice ID to review notes from developer about your project and make payments.",
    button: "Lookup Invoice"
  },
  contact: {
    title: "Contact",
    email: "dev.group@tower-integrations.com" // Placeholder, update if real email known
  }
}
